
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Check } from 'lucide-react';

export const MessageLimitsManagement: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold">Message Limits Management</h2>
          <p className="text-muted-foreground">AI Assistant usage is now unlimited</p>
        </div>
      </div>

      <Alert className="bg-green-50 border-green-200 dark:bg-green-900/20 dark:border-green-800">
        <Check className="h-4 w-4 text-green-600 dark:text-green-400" />
        <AlertDescription>
          <strong>Unlimited Access Enabled</strong>
          <br />
          All AI Assistant features are now available without usage limits. Users can send unlimited messages across all AI types (Guide, Performance, Trading Strategy, and Advisor).
        </AlertDescription>
      </Alert>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Check className="h-5 w-5 text-green-600" />
            System Status
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="text-center p-4 bg-green-50 dark:bg-green-900/20 rounded-lg">
              <div className="text-2xl font-bold text-green-600">∞</div>
              <div className="text-sm text-muted-foreground">Daily Limit</div>
            </div>
            <div className="text-center p-4 bg-green-50 dark:bg-green-900/20 rounded-lg">
              <div className="text-2xl font-bold text-green-600">∞</div>
              <div className="text-sm text-muted-foreground">Monthly Limit</div>
            </div>
          </div>
          
          <div className="mt-4 space-y-2">
            <div className="flex justify-between">
              <span>Guide AI:</span>
              <span className="text-green-600 font-medium">Unlimited</span>
            </div>
            <div className="flex justify-between">
              <span>Performance AI:</span>
              <span className="text-green-600 font-medium">Unlimited</span>
            </div>
            <div className="flex justify-between">
              <span>Trading Strategy AI:</span>
              <span className="text-green-600 font-medium">Unlimited</span>
            </div>
            <div className="flex justify-between">
              <span>Advisor AI:</span>
              <span className="text-green-600 font-medium">Unlimited</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
